module.exports = __webpack_public_path__ + "static/media/shopping-bag.89cc4286.svg";